/*
 * Copyright The OpenTelemetry Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { InstrumentationConfig } from '@opentelemetry/instrumentation';

export type CucumberInstrumentationConfig = InstrumentationConfig;

export enum AttributeNames {
  FEATURE_TAGS = 'cucumber.feature.tags',
  FEATURE_LANGUAGE = 'cucumber.feature.language',
  FEATURE_DESCRIPTION = 'cucumber.feature.description',
  SCENARIO_TAGS = 'cucumber.scenario.tags',
  SCENARIO_DESCRIPTION = 'cucumber.scenario.description',
  STEP_TYPE = 'cucumber.step.type',
  STEP_STATUS = 'cucumber.step.status',
  STEP_ARGS = 'cucumber.step.args',
}
